import { Card } from "react-bootstrap";
import { useLocation, useParams } from "react-router-dom";
import PageTitle from "../layouts/PageTitle";
import { useEffect, useMemo, useState } from "react";
import { getUserCohosts } from "../../services/UserServices/UserService";
import debounce from "lodash/debounce";
import Pagination from "../components/Pagination";
import PageContentLoader from "../components/TableLoader";

const Co_Hosts = () => {
  const [coHosts, setCoHosts] = useState([]);
  const { id } = useParams();
  const [sortBy, setSortBy] = useState("");
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage] = useState(10);
  const [totalItems, setTotalItems] = useState(0);
  const [loading, setLoading] = useState(false);

  const debouncedSearch = useMemo(
    () =>
      debounce((value) => {
        setSearch(value);
      }, 500),
    []
  );

  useEffect(() => {
    const getCohosts = async () => {
      try {
        setLoading(true);
        const res = await getUserCohosts(id, search, currentPage, 10);
        setCoHosts(res?.data?.data?.coHosts);
        setTotalItems(res?.data?.data.count);
      } catch (error) {
        console.error(error?.response?.data?.message);
      } finally {
        setLoading(false);
      }
    };
    if (id) {
      getCohosts();
    }
  }, [search, sortBy, currentPage, id]);

  const totalPages = Math.ceil(totalItems / itemsPerPage);
  const location = useLocation();
  const historyData = location.state?.history;

  return (
    <div className="qx-page">
      <PageTitle
        breadcrumbs={[
          {
            label: "User List",
            path: "/user-management",
          },
          {
            label: historyData?.user?.hostName || "User",
            path: `/user-details/${id}`,
            state: {
              history: {
                user: historyData?.user,
              },
            },
          },
          {
            label: "Co-Hosts",
          },
        ]}
      />

      <div className="qx-toolbar mb-3">
        <div className="qx-search-wrap" style={{ width: "100%", maxWidth: 420 }}>
          <input
            type="text"
            className="form-control"
            placeholder="Search by name, phone-number"
            onChange={(e) => debouncedSearch(e.target.value)}
          />
        </div>
      </div>

      {loading ? (
        <PageContentLoader message="Loading co-hosts..." />
      ) : (
        <Card className="qx-table-card">
          <Card.Body>
            {!coHosts.length ? (
              <p className="mb-0 text-center text-muted py-4">No data found</p>
            ) : (
              coHosts.map((host) => (
                <div
                  key={host._id}
                  className="cohost-item mb-3 p-3 rounded d-flex justify-content-between align-items-center"
                  style={{ border: "1px solid #eee", background: "#fafafa" }}
                >
                  <div>
                    <h5 className="fw-bold mb-2">{host.coHostName}</h5>
                    <p className="mb-0" style={{ color: "#A60000" }}>
                      📞{host.countryCode} {host.phoneNumber}
                    </p>
                  </div>
                </div>
              ))
            )}

            {coHosts.length > 0 && (
              <Pagination
                pageCount={totalPages}
                pageValue={currentPage}
                setPage={setCurrentPage}
                total={totalItems}
                pageSize={itemsPerPage}
              />
            )}
          </Card.Body>
        </Card>
      )}
    </div>
  );
};

export default Co_Hosts;
